import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DishCreatePricePage } from "../../dish-create/dish-create-price/dish-create-price";
import { Globals } from "../../../../globals";

/**
 * Generated class for the DishViewTopPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dish-view-top',
  templateUrl: 'dish-view-top.html',
})
export class DishViewTopPage {
  @Input() dish: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals) {

  }


  edit() {
    this.navCtrl.push(DishCreatePricePage, {
      update: true,
      dish_uid: this.dish.UID,
      price: this.dish.price,
      price_half: this.dish.price_half,
      price_tapa: this.dish.price_tapa,
      price_supplement: this.dish.price_supplement,
      price_combo_extra: this.dish.price_combo_extra,
      price_takeaway: this.dish.price_takeaway,
      dish_name: this.globals.nameLangSelectDish(this.dish),
      dish: this.dish,
      ean: this.dish.ean
    })
  }

  profitFoodCost(price, _foodcost, _parts, _type) {
    var foodcost = (_foodcost / _parts) * _type
    //Quitamos el tax del precio
    price = this.globals.createSubTotal(price, this.globals.RESTAURANT_TAX);
    return 100 - this.globals.regla3(price, foodcost);
  }


}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-view-top/dish-view-top.ts